import { jsx as _jsx } from "react/jsx-runtime";
import cx from 'classnames';
import styles from './styles.module.scss';
export var StepContentWrapper = function (_a) {
    var children = _a.children, className = _a.className;
    return _jsx("div", { className: cx(styles['step-content-wrapper'], className), children: children });
};
